<template>
  <div class="vm-thumb">
    <div class="vm-search-row">
      <div class="vm-search">
        <span class="vm-search-icon">
          <icon name="search"/>
        </span>
        <input
          ref="input"
          v-model="searchQuery"
          type="search"
          aria-label="Search"
          placeholder="Search"
          @keydown.enter.stop="changeQueryValue">
        <button
          v-show="searchQuery != ''"
          type="button"
          class="vm-search-clear"
          aria-label="Clear search"
          title="Clear search"
          @click="clearValue">
          <icon name="close-icon"/>
        </button>

      </div>
      <span
        v-if="searchQuery"
        class="vm-search-results">Results for “{{ searchQuery }}”</span>
    </div>
    <div
      id="stock-videos"
      class="thumbnail-box-conatiner"
      @scroll="stockVideoDivScroll">
      <div
        v-show="loader"
        class="loader-anchor">
        <Spinner
          :speed="1"
          size="huge"
          message="Loading..."
          class="inner-Loader"/>
      </div>
      <div
        v-if="videosFiltered.length"
        class="image-container">
        <div
          v-for="video in videosFiltered"
          :key="video.Id"
          :class="video.AudioUrl != null && video.AudioUrl != '' ? 'hasAudio' : ''"
          class="image-wrapper">
          <div
            class="image-item"
            @click="insertVideoToCanvas(video)">
            <img
              :src="video.ThumbnailVirtualPath"
              :style="thumbStyle(video)"
              alt="">
            <div class="play-icon">
              <i class="fa fa-play-circle"/>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else-if="!loader"
        class="vm-empty">
        No Results Matched
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from 'vue-simple-spinner';
import EventBus from '../../EventBus';
import ApplicationEventTypes from '../../mixins/ApplicationEventTypes';


export default {
  components: { Spinner },
  data() {
    return {
      searchQuery:    '',
      isFocused:      false,
      isFocusedOut:   false,
      imageData:      {},
      loader:         false,
      videos:         [],
      filteredVideos: {},
      pageNo:         1,
    };
  },
  computed: {
    videosFiltered() {
      return this.videos;
    },
  },
  mounted() {
    this.fetchStockVideos();
  },
  methods: {
    clearValue() {
      this.searchQuery       = '';
      this.isFocused         = false;
      this.$refs.input.value = '';
      this.videos            = [];
      this.pageNo            = 1;
      this.fetchStockVideos();
    },
    stockVideoDivScroll(e) {
      const { scrollTop, offsetHeight, scrollHeight } = e.target;
      if ((scrollTop + offsetHeight) >= scrollHeight) {
        this.pageNo++;
        this.fetchStockVideos();
      }
    },
    changeQueryValue(event) {
      this.searchQuery = event.target.value;
      if (this.searchQuery.length >= 3) {
        this.videos = [];
        this.pageNo = 1;
        this.fetchStockVideos();
      }
    },
    fetchStockVideos() {
      this.loader     = true;
      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4' ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      const url       = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetVideosByBank&domainURL=https://${domainUrl}.com/&bankId=AEE06AD4-4415-4388-ACB5-D81DA0698C84&keyword=${this.searchQuery.length >= 3 ? this.searchQuery : 'video'}&pageNo=${this.pageNo}`;

      const config = {
        method:        'get',
        maxBodyLength: Infinity,
        url,
        headers:       { },
      };

      axios.request(config)
        .then((response) => {
          const parser              = new DOMParser();
          const xmlParsed           = parser.parseFromString(response.data, 'text/xml');
          let videoCollectionResult = xmlParsed.getElementsByTagName('SearchVideosByBankResult');

          videoCollectionResult[0] && (videoCollectionResult = videoCollectionResult[0].innerHTML);
          const videoResult = JSON.parse(videoCollectionResult);
          this.videos.push(...videoResult.Items);
          this.loader = false;
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
        });
    },
    enableVideoMode() {
      const isVideoModeOn = this.$store.getters['activeProduct/getIsVideoMoodOn'];
      if (!isVideoModeOn) {
        this.$store.commit('activeProduct/updateIsVideoMoodOn', true);
        EventBus.$emit(ApplicationEventTypes.Video.ToggleVideoMood, true);
      }
    },
    thumbStyle(video) {
      const width  = Number(video.Width);
      const height = Number(video.Height);
      if (!(width > 0 && height > 0)) {
        return { backgroundColor: '#efefef' };
      }
      return {
        backgroundColor: '#efefef',
        aspectRatio:     `${width} / ${height}`,
      };
    },
    insertVideoToCanvas(videoObj) {
      if (this.$store.getters.getDisplayAddVideoModal) {
        const videoData = {
          Id:           '',
          Name:         videoObj.Name,
          videoDetails: {
            VideoSourceUrl: videoObj.LowResUrl,
            duration:       videoObj.Duration,
            width:          videoObj.Width,
            height:         videoObj.Height,
            mimeType:       'video/mp4',
            audio:          (!videoObj.AudioUrl || videoObj.AudioUrl.length < 10) ? 'https://video-processing.bankmarketingcenter.com/ffmpeg-video/audio-6ybTJmVkIN.mp3' : videoObj.AudioUrl,
            videoHighRes:   videoObj.HighResUrl,
          },
          AlternativeVideoUrlsResVersion: [],
        };

        videoData.AlternativeVideoUrlsResVersion.push(videoObj);
        EventBus.$emit('AddNewVideoOnCanvas', videoData);
        this.enableVideoMode();
        EventBus.$emit('SetPageVideoLength', videoObj.Duration);
        this.$store.commit('setDisplayAddVideoModal', false);
        this.$store.commit('setIsVideoModel', false);
        return;
      }
      EventBus.$emit(ApplicationEventTypes.ImageObjectEvents.SELECTED_VIDEO_FOR_LEFT_PANEL, videoObj);
    },
  },
};
</script>

<style lang="scss" scoped>
.vm-thumb {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.vm-search-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.vm-search {
  width: 100%;
  max-width: 100%;
  height: 38px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 8px 0 12px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  box-shadow: inset 0 0 0 1px #E7E9ED;
}

.vm-search:focus-within {
  box-shadow: inset 0 0 0 1.5px #1570EF, 0 0 0 3px rgba(21, 112, 239, 0.15);
}

.vm-search-icon,
.vm-search-clear {
  display: flex;
  flex-shrink: 0;
  color: #5E6573;
}

.vm-search ::v-deep .icon {
  min-width: 0;
  min-height: 0;
  color: inherit;
}

.vm-search-icon ::v-deep .icon svg {
  width: 16px;
  height: 16px;
}

.vm-search-clear ::v-deep .icon svg {
  width: 14px;
  height: 14px;
}

.vm-search input {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  font-family: inherit;
  font-size: 13.5px;
  color: #14161B;
  box-shadow: none;
}

.vm-search input::-webkit-search-cancel-button {
  display: none;
}

.vm-search-clear {
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  padding: 0;
  cursor: pointer;
  background: transparent;
  color: #3D4350;
}

.vm-search kbd {
  font-family: 'Geist Mono', ui-monospace, 'SF Mono', Menlo, monospace;
  font-size: 10.5px;
  color: #5E6573;
  background: #F3F4F6;
  border-radius: 5px;
  padding: 2px 6px;
}

.vm-search-results {
  font-size: 12.5px;
  color: #5E6573;
}

.thumbnail-box-conatiner {
  position: relative;
  flex: 1 1 auto;
  min-height: 240px;
  overflow: auto;
  padding: 4px;
}

.image-container {
  columns: 4;
  column-gap: 10px;
}

.image-wrapper {
  break-inside: avoid;
  width: 100%;
  margin-bottom: 10px;
}

.image-item {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  background: #efefef;
  cursor: pointer;
}

.image-item img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 10px;
}

.play-icon {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.12);
  color: #fff;
  font-size: 36px;
  pointer-events: none;
}

.vm-empty {
  padding: 32px 0;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #D92D20;
}

.loader-anchor {
  position: sticky;
  top: 0;
  z-index: 56;
  height: 0;
  pointer-events: none;
}

.inner-Loader {
  position: absolute;
  top: 210px;
  left: 40px;
  width: calc(100% - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 56;
  pointer-events: none;

  .vue-simple-spinner-text {
    color: #52A7E1 !important;
  }
}

.hasAudio {
  position: relative;

  &:after {
    content: "\f028";
    font: normal normal normal 14px/1 FontAwesome;
    color: #fff;
    position: absolute;
    right: 10px;
    top: 8px;
    font-size: 18px;
    z-index: 1;
    pointer-events: none;
  }
}

@media screen and (max-width: 980px) {
  .image-container {
    columns: 3;
  }
}

@media screen and (max-width: 720px) {
  .image-container {
    columns: 2;
  }
}

@media screen and (max-width: 460px) {
  .image-container {
    columns: 1;
  }
}
</style>
